export default "__VITE_ASSET__DOKi7bbR__"